import { ButtonV2 } from "@Modules/common/ButtonV2";
import { IFormFieldV2 } from "@Modules/common/Form/FormFieldV2/IFormFieldV2";
import { FormLineV2 } from "@Modules/common/Form/FormLineV2";
import {
    evaluateHideComponent,
    evaluateRenderMobileView,
} from "@Modules/eventPage/utils/render";
import { BsCaretDownFill as DownIcon } from "@react-icons/all-files/bs/BsCaretDownFill";
import { BsCaretUpFill as UpIcon } from "@react-icons/all-files/bs/BsCaretUpFill";
import { classNames } from "repoV2/utils/common/render/classNames";
import React, { FC, useState } from "react";
import commonStyles from "../commonStyles.module.scss";
import { getShowCompactEventPage } from "../CompactEventPage/utils/getShowCompactEventPage";
import CTAButtonRender from "../CTAButtonRender";
import ExpressInterestCustomQuestions from "../ExpressInterestCustomQuestions";
import { IExpressInterestProps } from "./ExpressInterest";
import styles from "./expressInterest.module.scss";
import useExpressInterest from "./utils/useExpressInterest";

// TODO @mayank: get backdrop + click functionality implemented in mobile render
const ExpressInterest: FC<IExpressInterestProps> = props => {
    const [isFormExpandedInMobile, setIsFormExpandedInMobile] = useState(false); // since this hook is specific to this component, we are keeping this here
    const { showOn, isMobileDeviceWidth, urlQueryParams, isSoldOut } = props;
    const showCompactEventPage = getShowCompactEventPage({ urlQueryParams });

    const {
        hideComponent,
        title,
        customQuestions,
        customAnswers,
        setCustomAns,
        customAnswerThumbnails,
        setCustomAnsThumbnail,
        showCustomQns,
        FORM_ENUM,
        getFieldProps,
        hasError,
        showErrors,
        onSubmit,
        listingExpressInterestCta,
    } = useExpressInterest(props);

    const expandBtnLabel = isSoldOut ? "" : "Contact the creator";
    const closeBtnLabel = isSoldOut ? "" : "close";

    const getClassName = (field: IFormFieldV2) => {
        if (!field) return "";

        return field.inputType === "select"
            ? styles.countryCodeDropdown
            : classNames(
                  styles.formInput,
                  hasError(field) && styles.formInputError
              );
    };

    const renderMobileView = evaluateRenderMobileView({
        isMobileDeviceWidth,
        showCompactEventPage,
    });
    if (
        evaluateHideComponent({
            hideComponent,
            isMobile: renderMobileView,
            showOn,
        })
    ) {
        return null;
    }

    const BaseComponent = (
        <>
            <div className="d-flex align-items-center justify-content-between">
                <div className={commonStyles.sidebarSectionTitle}>
                    {/* could not figure out why but when rendered without the empty tag(`<>`),
                    the title gets wrapped in `<em>` and makes the title italic */}
                    <>{title}</>
                </div>
                {renderMobileView ? (
                    <ButtonV2
                        design="plain"
                        applyTheme
                        className="d-flex align-items-end small"
                        onClick={() =>
                            setIsFormExpandedInMobile(!isFormExpandedInMobile)
                        }
                    >
                        {isFormExpandedInMobile
                            ? closeBtnLabel
                            : expandBtnLabel}
                        {/* TODO: use const showGuestInfoModal for `Contact the creator` */}
                        &nbsp;
                        {isFormExpandedInMobile ? <DownIcon /> : <UpIcon />}
                    </ButtonV2>
                ) : null}
            </div>
            <form
                className={styles.form}
                onSubmit={e => {
                    e.preventDefault();
                    if (renderMobileView && !isFormExpandedInMobile) {
                        setIsFormExpandedInMobile(true);
                        return;
                    }
                    onSubmit(e);
                }}
            >
                {(renderMobileView && isFormExpandedInMobile) ||
                !renderMobileView ? (
                    <>
                        {Object.values(FORM_ENUM).map(field => {
                            const { preField, ...restFieldProps } = field;

                            const fieldProps = getFieldProps(restFieldProps);
                            const preFieldProps = getFieldProps(preField);

                            const fieldClassName = getClassName(field);
                            const preFieldClassName = getClassName(preField);

                            return (
                                <div
                                    key={field.id}
                                    className={styles.formField}
                                >
                                    <FormLineV2
                                        field={{
                                            ...fieldProps!,
                                            className: fieldClassName,
                                        }}
                                        preField={
                                            preFieldProps && {
                                                ...preFieldProps,
                                                className: preFieldClassName,
                                            }
                                        }
                                        classNames={{
                                            label: styles.formTitle,
                                            mandatory: styles.mandatory,
                                            errorMessage: styles.fieldError,
                                            inputContainer:
                                                styles.fieldContainer,
                                        }}
                                    />
                                </div>
                            );
                        })}

                        {/*
                        TODO @harshit: 
                        1. better to include custom questions in the form hook : done
                        */}
                        {showCustomQns && (
                            <ExpressInterestCustomQuestions
                                questions={customQuestions}
                                answers={customAnswers}
                                setAnswers={setCustomAns}
                                thumbnails={customAnswerThumbnails}
                                setThumbnails={setCustomAnsThumbnail}
                                showError={showErrors}
                            />
                        )}
                    </>
                ) : null}
                <div className={classNames(styles.submitContainer)}>
                    <CTAButtonRender
                        ctaText={listingExpressInterestCta}
                        showArrow
                        type="submit"
                        className="w-100"
                    />
                </div>
            </form>
        </>
    );

    if (!renderMobileView) return BaseComponent;
    return <div className={styles.mobileContainer}>{BaseComponent}</div>;
};

export default ExpressInterest;
